import { useState, useEffect } from 'react'
import axios from 'axios'
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Spinner,
  InputGroup
} from 'react-bootstrap'
import { Search } from 'lucide-react'
import Header from '../Components/Header'

const ITEMS_PER_PAGE = 5

export default function FeedsPage() {
  const [feedItems, setFeedItems] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [hasMore, setHasMore] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')
  const [activeTab, setActiveTab] = useState('All Updates')
  const token = localStorage.getItem('jwttoken')

  useEffect(() => {
    loadFeedItems()
  }, [])

  const loadFeedItems = async () => {
    setLoading(true)
    try {
      const response = await axios.get(
        `https://kaasbackend.vetrinahealthcare.com/socialapp/news_feed/`,
        {
          params: { page: currentPage, limit: ITEMS_PER_PAGE },
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      )

      if (response.data.length > 0) {
        setFeedItems((prev) => [...prev, ...response.data])
        setCurrentPage((prev) => prev + 1)
      } else {
        setHasMore(false)
      }
    } catch (error) {
      console.error('Error fetching feed items:', error)
    }
    setLoading(false)
  }

  const handleSearch = (e) => {
    setSearchTerm(e.target.value)
  }

  const filteredItems = feedItems.filter(
    (item) =>
      item.action.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.group?.toString().toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <>
      <Header />
      <Container className="py-4" style={{ marginTop: "4.5rem" }}>
  {/* CENTERED HEADER + SEARCH */}
  <div className="d-flex flex-column align-items-center text-center mb-5">
    <h1
      className="fw-bold mb-3"
      style={{
        fontSize: "40px",
        fontWeight: "950",
        background: "linear-gradient(90deg, #f4811e, #B8529E, #3953A3)",
        backgroundSize: "300% 100%",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        animation: "triColorMove 4s ease-in-out infinite",
      }}
    >
      News Feed
    </h1>

    <div className="position-relative" style={{ width: "350px", maxWidth: "90%" }}>
       <InputGroup style={{ width: "400px", maxWidth: "90%" }}>
    <InputGroup.Text
      className="bg-white border-end-0 rounded-start-pill"
      style={{ borderColor: "#e9ecef", paddingLeft: "20px" }}
    >
      <Search size={18} color="#6c757d" />
    </InputGroup.Text>

    <Form.Control
      placeholder="   Search Groups..."
      className="border-start-0 rounded-end-pill"
      style={{
        boxShadow: "none",
        borderColor: "#e9ecef",
        paddingLeft: "10px",
        fontSize: "16px",
      }}
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
    />
  </InputGroup>
    </div>

    {/* REQUIRED FOR GRADIENT ANIMATION */}
    <style>
      {`
        @keyframes triColorMove {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
      `}
    </style>
  </div>


        {loading && feedItems.length === 0 ? (
          <div
            className='d-flex justify-content-center align-items-center'
            style={{ minHeight: '300px' }}
          >
            <Spinner animation='border' role='status' variant='primary'>
              <span className='visually-hidden'>Loading...</span>
            </Spinner>
          </div>
        ) : filteredItems.length > 0 ? (
          <Row>
            <Col>
              {filteredItems.map((item) => (
                <Card key={item.id} className='mb-3 border'>
                  <Card.Body>
                    <div className='d-flex align-items-start mb-2'>
                      <div>
                        <strong>User {item.user}</strong> {item.action} in Group{' '}
                        {item.group}
                        <div className='text-muted small'>
                          {new Date(item.created_at).toLocaleString()}
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              ))}

              {hasMore && (
                <div className='text-center my-4'>
                  <Button
                    variant='primary'
                    onClick={loadFeedItems}
                    disabled={loading}
                    className='px-4'
                  >
                    {loading ? (
                      <>
                        <Spinner
                          as='span'
                          animation='border'
                          size='sm'
                          role='status'
                          aria-hidden='true'
                          className='me-2'
                        />
                        Loading...
                      </>
                    ) : (
                      'Load More'
                    )}
                  </Button>
                </div>
              )}
            </Col>
          </Row>
        ) : (
          <Row>
            <Col className='text-center py-5'>
              <h4 className='text-muted'>No feed items found</h4>
              <p>Try adjusting your search or filters</p>
            </Col>
          </Row>
        )}
      </Container>
    </>
  )
}
